<div class="directorio-container">
  <h1 class="txt-section">Directorio</h1>
  <div class="directorio_container">
    <div class="form">
      <table>
        <thead>
          <tr>
            <th style="border-top-left-radius: 8px;">SUCURSAL</th>
            <th>TELÉFONO</th>
            <th>DIRECCIÓN OCURRE</th>
            <th style="border-top-right-radius: 8px;">HORARIO</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of directoriosData">
            <td data-title='SUCURSAL'><strong> {{item.sucursal}}</strong></td>
            <td data-title='TELÉFONO'>
              <a *ngIf="item.telefono" [href]="'tel:' + item.telefono">{{item.telefono}}</a>
            </td>
            <td data-title='DIRECCIÓN OCURRE'>{{item.direccion}}</td>
            <td data-title='HORARIO'>{{item.horario}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>